<template>
    <div>
<!--        <strong>{{ $_.get(activity, "actorUser.name") }}</strong>-->
<!--        updated settings-->
        <span v-html="$t('notification.settingUpdate', {user:$_.get(activity, 'actorUser.name') })"></span>
        <pre class="quote" v-if="$_.get(activity, 'payload.updatedFields')">{{
            JSON.stringify($_.get(activity, "payload.updatedFields"), null, 2)
        }}</pre>

    </div>
</template>
<script>
import Vue from "vue";

export default Vue.extend({
    name: "SettingsUpdated",
    props: {
        activity: {
            type: Object,
            default: () => ({}),
        },
    },
});
</script>

<style scoped lang="scss"></style>
